import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  align-items: center;
  border: none;
  background: transparent;
  padding: 0;
  gap: 8px;
  color: #73B1BB;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;

  svg {
    transition: transform 0.3s;
  }

  :hover {
    svg {
      transform: translateX(5px);
    }
  }
`;

export const Title = styled.div`
  width: 100px;
  display: flex;
  justify-content: flex-end;
  line-height: 16px;
`


export const BackIcon = styled.div`
  width: 30px;
  margin-right: 5px;
`